import { render, staticRenderFns } from "./TaskActivation.vue?vue&type=template&id=12dd9b59&scoped=true"
import script from "./TaskActivation.vue?vue&type=script&lang=js"
export * from "./TaskActivation.vue?vue&type=script&lang=js"
import style0 from "./TaskActivation.vue?vue&type=style&index=0&id=12dd9b59&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12dd9b59",
  null
  
)

export default component.exports